module.exports = __webpack_public_path__ + "img/jpg-bg.afd9c55d.jpg";